// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_SEARCH_IN_BAZAAR = "H\u013eadaj v baz\u00e1ri";
export const HOMEPAGE_SEARCH_IN_BAZAAR_PLACEHOLDER = "H\u013eadaj inzer\u00e1ty v baz\u00e1ri";
